// extracted by mini-css-extract-plugin
export default {"active-row":"SearchCustomerModal_active-row__lqtk+","all-rows":"SearchCustomerModal_all-rows__yz1Ry"};